import request from '../utils/request'
const baseUrl = process.env.NODE_ENV === 'production' ? '' : '/packmap'
// const baseUrl = ''
export function getStatisticsInfo (parkfieldId) {
  return request({
    url: baseUrl + '/lcchargerlog/getStatisticsInfo',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}
export function getStatisticsInfo1day (parkfieldId) {
  return request({
    url: baseUrl + '/lcchargerlog/getStatisticsInfo1day',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}
export function getInfo7days (parkfieldId) {
  return request({
    url: baseUrl + '/lcchargerlog/getInfo7days',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/lcChargerLog.js